import debug from 'debug';
import fc from './common/lib';
import Vue from 'vue';
import initLayout from '@fastcampus/layouts/src/main';
import { initHeader } from './header';
import { initClosedCourse } from './closed-course';
import { initPageCommonFormApp } from './page-common-form';
import { initComposedLayout } from './composed-layout';
import { initCouponPopup } from './coupon-popup';
import { initCarousel } from './common/carousel';
import { initModalStopIE } from './popup/stop-ie';
import { InitDynamicImage } from '@fastcampus/browser-util';
import { initSnackBar } from './email-snackbar';
import { registerFilters } from './filters';

// test for invoke vue component
import { initVue } from './app';

// 정리 예정
import { daumPostHelper } from './common/postal_code_finder';

if (process.env.NODE_ENV === 'prod') {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
}

registerFilters();

fc.init(debug).run([
  initModalStopIE,
  initCouponPopup,
  initHeader,
  initVue,
  daumPostHelper,
  initClosedCourse,
  initPageCommonFormApp,
  initComposedLayout,
  InitDynamicImage,
  initCarousel,
  initLayout,
  initSnackBar,
]);
